import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApiMembersInsightPostCommentsLikedEmployeesIndexResponseType } from "~/domains";

type RequestDataType = {
  insightPostCommentId: string;
  page?: number;
};

const request = async ({
  insightPostCommentId,
  page = 1,
}: RequestDataType): Promise<ApiMembersInsightPostCommentsLikedEmployeesIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiMembersInsightPostCommentsLikedEmployeesIndexResponseType>(
      `/api/members/insight_post_comments/${insightPostCommentId}/liked_employees`,
      { page },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  insightPostCommentId: string;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisMembersInsightPostCommentsLikedEmployeesIndex = ({
  insightPostCommentId,
  config = {},
}: PropsType): UseInfiniteQueryResult<ApiMembersInsightPostCommentsLikedEmployeesIndexResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisMembersInsightPostCommentsLikedEmployeesIndex", insightPostCommentId],
    ({ pageParam }) => {
      return request({
        insightPostCommentId,
        page: pageParam as number | undefined,
      });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
